// @ts-nocheck
import { Tag } from "@shared/antd/tag";
import { Row } from "@shared/antd/row";
import { Card } from "@shared/antd/card";
import React, { Component } from "react";
import Img from "../../components/Img";
import { RouteComponentProps, withRouter } from "react-router";
import { FileDescriptor } from "../../../cuba/entities/base/sys$FileDescriptor";
import { downloadFile } from "../../util/util";
import { FormattedMessage } from "react-intl";
import { getImageById } from "../../shared/api";

export type FeedItemModel = {
  id: string;
  url: string;
  img?: Promise<string>;
  date: string;
  title: string;
  text: string;
  attachments?: FileDescriptor[];
};

export const TimeLinePath = "/news";

class TimeLineItemFull extends Component<RouteComponentProps & FeedItemModel> {
  render() {
    const { id, title, text, image, url, attachments } = this.props.history
      .location.state as any;


    return (
      <>
        <Row key={id}>
          <div className={'[&_.no-image]:hidden'}>
          <Img
            className="news-image"
            type="promise"
            style={{ margin: 25 }}
            src={getImageById(image)}
          />
          </div>
        </Row>
        <Row>
          <span>
            <h2 style={{ marginLeft: 25 }}>
              <a className="underline" href={url}>
                {title}
              </a>
            </h2>
          </span>
        </Row>
        <Row>
          <div
            style={{ marginLeft: 25 }}
            dangerouslySetInnerHTML={{ __html: text }}
          />
          <Row>
            <Card
              size="small"
              title={<FormattedMessage id="attachments" />}
              style={{ margin: "10px" }}
            >
              <br />
              {attachments ? (
                attachments.map((a: any) => {
                  return (
                    <Tag
                      style={{ margin: "10px" }}
                      color={"blue"}
                      onClick={() => {
                        downloadFile(
                          (a as FileDescriptor).id,
                          (a as FileDescriptor).name as string,
                          (a as FileDescriptor).extension as string,
                          "",
                        );
                      }}
                    >
                      {" "}
                      {(a as FileDescriptor).name}
                    </Tag>
                  );
                })
              ) : (
                <></>
              )}
            </Card>
          </Row>
        </Row>
      </>
    );
  }
}

export const TimeLineFull = withRouter(TimeLineItemFull);
// export default withRouter(TimeLineItemFull);
